module.exports = __webpack_public_path__ + "img/mails_title.92342cff.svg";